import { all } from 'redux-saga/effects'
import { bagSagas } from 'models/bag/sagas'
import { compositionsSagas } from 'models/compositions/sagas'
import { favoritesSagas } from 'models/favorites/sagas'
import { furnitureSagas } from 'models/furniture/sagas'
import { supportSagas } from 'models/support/sagas'
import { trackingSagas } from 'models/tracking/sagas'

function* rootSaga() {
    yield all([...furnitureSagas, ...trackingSagas, ...compositionsSagas, ...bagSagas, ...favoritesSagas, ...supportSagas])
}

export default rootSaga
